import { useContext } from "react";
import { ValidationResult } from "sprint-common-web";

import { GetConformingCloudAssetsRequest } from "../../../../assets/api/GetConformingCloudAssetsRequest";
import { GetConformingCloudAssetsResponse } from "../../../../assets/api/GetConformingCloudAssetsResponse";
import { GetConformingOnPremAssetsRequest } from "../../../../assets/api/GetConformingOnPremAssetsRequest";
import { GetConformingOnPremAssetsResponse } from "../../../../assets/api/GetConformingOnPremAssetsResponse";
import { AppConfigContext } from "../../../../core/configuration/Configuration";
import { useAuthorizedFetch } from "../../../../core/data-access/useAuthorizedFetch";
import { SearchAssetsContentAggregationsRequest } from "../search/content-requests-reposnses/SearchAssetsContentAggregationsRequest";
import { SearchAssetsContentAggregationsResponse } from "../search/content-requests-reposnses/SearchAssetsContentAggregationsResponse";
import { SearchMoviesAssetsRequest } from "../search/movie-requests-responses/SearchMoviesAssetsRequest";
import { SearchTvSeriesAssetsRequest } from "../search/tv-series-requests-responses/SearchTvSeriesAssetsRequest";
import { GetCloudAssetsOperationsRequest } from "./asset-operations/GetCloudAssetsOperationsRequest";
import { GetCloudAssetsOperationsResponse } from "./asset-operations/GetCloudAssetsOperationsResponse";
import { GetOnPremAssetsOperationsRequest } from "./asset-operations/GetOnPremAssetsOperationsRequest";
import { GetOnPremAssetsOperationsResponse } from "./asset-operations/GetOnPremAssetsOperationsResponse";
import { UpdateBulkCloudAssetContentRequest } from "./bulk-content/UpdateBulkCloudAssetContentRequest";
import { UpdateBulkCloudAssetContentResponse } from "./bulk-content/UpdateBulkCloudAssetContentResponse";
import { ValidateBulkCloudAssetContentRequest } from "./bulk-content/ValidateBulkCloudAssetContentRequest";
import { ValidateBulkCloudAssetContentResponse } from "./bulk-content/ValidateBulkCloudAssetContentResponse";
import { DeprecateCloudAssetGroupRequest } from "./deprecate/DeprecateCloudAssetGroupRequest";
import { DeprecateCloudAssetRequest } from "./deprecate/DeprecateCloudAssetRequest";
import { DeprecateOnPremAssetGroupRequest } from "./deprecate/DeprecateOnPremAssetGroupRequest";
import { DeprecateOnPremAssetRequest } from "./deprecate/DeprecateOnPremAssetRequest";
import { ValidateIfAbleToDeprecateCloudAssetRequest } from "./deprecate/validate/ValidateIfAbleToDeprecateCloudAssetRequest";
import { ValidateIfAbleToDeprecateOnPremAssetRequest } from "./deprecate/validate/ValidateIfAbleToDeprecateOnPremAssetRequest";
import { GetCloudAssetDetailsRequest } from "./details/GetCloudAssetDetailsRequest";
import { GetCloudAssetDetailsResponse } from "./details/GetCloudAssetDetailsResponse";
import { GetOnPremAssetDetailsRequest } from "./details/GetOnPremAssetDetailsRequest";
import { GetOnPremAssetDetailsResponse } from "./details/GetOnPremAssetDetailsResponse";
import { UpdateCloudAssetContentRequest } from "./details/UpdateCloudAssetContentRequest";
import { UpdateCloudAssetContentResponse } from "./details/UpdateCloudAssetContentResponse";
import { UpdateCloudSoundtrackAssetLanguageRequest } from "./details/UpdateCloudSoundtrackAssetLanguageRequest";
import { UpdateCloudSoundtrackAssetLanguageResponse } from "./details/UpdateCloudSoundtrackAssetLanguageResponse";
import { UpdateCloudSubtitleAssetLanguageRequest } from "./details/UpdateCloudSubtitleAssetLanguageRequest";
import { UpdateCloudSubtitleAssetLanguageResponse } from "./details/UpdateCloudSubtitleAssetLanguageResponse";
import { UpdateCloudVideoAssetSubtitleRequest } from "./details/UpdateCloudVideoAssetSubtitleRequest";
import { UpdateCloudVideoAssetSubtitleResponse } from "./details/UpdateCloudVideoAssetSubtitleResponse";
import { UpdateCloudVideoAssetTechnicalRequest } from "./details/UpdateCloudVideoAssetTechnicalRequest";
import { UpdateCloudVideoAssetTechnicalResponse } from "./details/UpdateCloudVideoAssetTechnicalResponse";
import { UpdateOnPremAssetContentRequest } from "./details/UpdateOnPremAssetContentRequest";
import { UpdateOnPremAssetContentResponse } from "./details/UpdateOnPremAssetContentResponse";
import { UpdateOnPremAssetLibraryRequest } from "./details/UpdateOnPremAssetLibraryRequest";
import { UpdateOnPremAssetLibraryResponse } from "./details/UpdateOnPremAssetLibraryResponse";
import { UpdateOnPremAudioAssetTechnicalRequest } from "./details/UpdateOnPremAudioAssetTechnicalRequest";
import { UpdateOnPremAudioAssetTechnicalResponse } from "./details/UpdateOnPremAudioAssetTechnicalResponse";
import { UpdateOnPremSoundtrackAssetLanguageRequest } from "./details/UpdateOnPremSoundtrackAssetLanguageRequest";
import { UpdateOnPremSoundtrackAssetLanguageResponse } from "./details/UpdateOnPremSoundtrackAssetLanguageResponse";
import { UpdateOnPremSubtitleAssetLanguageRequest } from "./details/UpdateOnPremSubtitleAssetLanguageRequest";
import { UpdateOnPremSubtitleAssetLanguageResponse } from "./details/UpdateOnPremSubtitleAssetLanguageResponse";
import { UpdateOnPremVideoAssetSubtitleRequest } from "./details/UpdateOnPremVideoAssetSubtitleRequest";
import { UpdateOnPremVideoAssetSubtitleResponse } from "./details/UpdateOnPremVideoAssetSubtitleResponse";
import { UpdateOnPremVideoAssetTechnicalRequest } from "./details/UpdateOnPremVideoAssetTechnicalRequest";
import { UpdateOnPremVideoAssetTechnicalResponse } from "./details/UpdateOnPremVideoAssetTechnicalResponse";
import { ValidateCloudAssetContentRequest } from "./details/ValidateCloudAssetContentRequest";
import { ValidateCloudSoundtrackAssetLanguageRequest } from "./details/ValidateCloudSoundtrackAssetLanguageRequest";
import { ValidateCloudSubtitleAssetLanguageRequest } from "./details/ValidateCloudSubtitleAssetLanguageRequest";
import { ValidateCloudVideoAssetUniquenessRequest } from "./details/ValidateCloudVideoAssetUniquenessRequest";
import { ValidateOnPremAssetContentRequest } from "./details/ValidateOnPremAssetContentRequest";
import { ValidateOnPremSubtitleAssetLanguageRequest } from "./details/ValidateOnPremSubtitleAssetLanguageRequest";
import { ValidateOnPremVideoAssetUniquenessRequest } from "./details/ValidateOnPremVideoAssetUniquenessRequest";
import { GetCloudAssetPreviewRequest } from "./get-preview/GetCloudAssetPreviewRequest";
import { GetCloudAssetPreviewResponse } from "./get-preview/GetCloudAssetPreviewResponse";
import { GetCloudVideoAssetsRequest } from "./get-cloud-video-assets/GetCloudVideoAssetsRequest";
import { GetCloudVideoAssetsResponse } from "./get-cloud-video-assets/GetCloudVideoAssetsResponse";
import { SearchAncillaryAssetsRequest } from "./search/ancillary-requests-responses/SearchAncillaryAssetsRequest";
import { SearchAncillaryAssetsResponse } from "./search/ancillary-requests-responses/SearchAncillaryAssetsResponse";
import { GetLookupAssetsRequest } from "./search/lookup-assets/GetLookupAssetsRequest";
import { GetLookupAssetsResponse } from "./search/lookup-assets/GetLookupAssetsResponse";
import { GetLookupCloudAssetsRequest } from "./search/lookup-cloud-assets/GetLookupCloudAssetsRequest";
import { GetLookupCloudAssetsResponse } from "./search/lookup-cloud-assets/GetLookupCloudAssetsResponse";
import { SearchMoviesAssetsResponse } from "./search/movie-requests-responses/SearchMoviesAssetsResponse";
import { SearchTvSeriesAssetsResponse } from "./search/tv-series-requests-responses/SearchTvSeriesAssetsResponse";

export const useAssetsApi = () => {
    const appConfigContext = useContext(AppConfigContext);
    const baseUrl = `${appConfigContext.masterConfig.apiUrl}/assets`;
    const { httpGet, httpPut, httpPost } = useAuthorizedFetch();

    const searchAssetsContentAggregations = async (
        request: SearchAssetsContentAggregationsRequest
    ): Promise<SearchAssetsContentAggregationsResponse> => {
        return httpGet<SearchAssetsContentAggregationsResponse>(
            `${baseUrl}/search/search-content-aggregations`,
            request
        );
    };

    const searchMovies = async (request: SearchMoviesAssetsRequest): Promise<SearchMoviesAssetsResponse> => {
        return httpGet<SearchMoviesAssetsResponse>(`${baseUrl}/search/movies`, request);
    };

    const searchTvSeries = async (request: SearchTvSeriesAssetsRequest): Promise<SearchTvSeriesAssetsResponse> => {
        return httpGet<SearchTvSeriesAssetsResponse>(`${baseUrl}/search/tv-series`, request);
    };

    const searchAncillary = async (request: SearchAncillaryAssetsRequest): Promise<SearchAncillaryAssetsResponse> => {
        return httpGet<SearchAncillaryAssetsResponse>(`${baseUrl}/search/ancillaries`, request);
    };

    const deprecateOnPremAsset = async (request: DeprecateOnPremAssetRequest): Promise<void> => {
        return httpPut(`${baseUrl}/on-prem/deprecate`, request);
    };

    const deprecateOnPremAssetGroup = async (request: DeprecateOnPremAssetGroupRequest): Promise<void> => {
        return httpPut(`${baseUrl}/on-prem/deprecate-group`, request);
    };

    const getOnPremAssetsOperations = async (
        request: GetOnPremAssetsOperationsRequest
    ): Promise<GetOnPremAssetsOperationsResponse> => {
        return httpGet<GetOnPremAssetsOperationsResponse>(`${baseUrl}/on-prem/get-operations`, request);
    };

    const getCloudAssetsOperations = async (
        request: GetCloudAssetsOperationsRequest
    ): Promise<GetCloudAssetsOperationsResponse> => {
        return httpGet<GetOnPremAssetsOperationsResponse>(`${baseUrl}/cloud/get-operations`, request);
    };

    const getCloudAssetDetails = async (
        request: GetCloudAssetDetailsRequest
    ): Promise<GetCloudAssetDetailsResponse> => {
        return httpGet<GetCloudAssetDetailsResponse>(`${baseUrl}/cloud/get-asset-details`, request);
    };

    const updateCloudVideoAssetSubtitle = async (
        request: UpdateCloudVideoAssetSubtitleRequest
    ): Promise<UpdateCloudVideoAssetSubtitleResponse> => {
        return httpPut(`${baseUrl}/cloud/update-video-subtitle`, request);
    };

    const updateCloudVideoAssetTechnical = async (
        request: UpdateCloudVideoAssetTechnicalRequest
    ): Promise<UpdateCloudVideoAssetTechnicalResponse> => {
        return httpPut(`${baseUrl}/cloud/update-video-technical`, request);
    };

    const updateCloudSubtitleAssetLanguage = async (
        request: UpdateCloudSubtitleAssetLanguageRequest
    ): Promise<UpdateCloudSubtitleAssetLanguageResponse> => {
        return httpPut(`${baseUrl}/cloud/update-subtitle-language`, request);
    };

    const updateCloudSoundtrackAssetLanguage = async (
        request: UpdateCloudSoundtrackAssetLanguageRequest
    ): Promise<UpdateCloudSoundtrackAssetLanguageResponse> => {
        return httpPut(`${baseUrl}/cloud/update-soundtrack-language`, request);
    };

    const updateCloudAssetContent = async (
        request: UpdateCloudAssetContentRequest
    ): Promise<UpdateCloudAssetContentResponse> => {
        return httpPut(`${baseUrl}/cloud/update-content`, request);
    };

    const validateCloudSubtitleAssetLanguage = async (
        request: ValidateCloudSubtitleAssetLanguageRequest
    ): Promise<ValidationResult> => {
        return httpGet(`${baseUrl}/cloud/validate-subtitle-language`, request);
    };

    const validateCloudAssetContent = async (request: ValidateCloudAssetContentRequest): Promise<ValidationResult> => {
        return httpPost(`${baseUrl}/cloud/validate-content`, request);
    };

    const validateBulkCloudAssetContent = async (
        request: ValidateBulkCloudAssetContentRequest
    ): Promise<ValidateBulkCloudAssetContentResponse> => {
        return httpPost(`${baseUrl}/cloud/validate-bulk-content`, request);
    };

    const updateBulkCloudAssetContent = async (
        request: UpdateBulkCloudAssetContentRequest
    ): Promise<UpdateBulkCloudAssetContentResponse> => {
        return httpPut(`${baseUrl}/cloud/update-bulk-content`, request);
    };

    const validateCloudSoundtrackAssetLanguage = async (
        request: ValidateCloudSoundtrackAssetLanguageRequest
    ): Promise<ValidationResult> => {
        return httpGet(`${baseUrl}/cloud/validate-soundtrack-language`, request);
    };

    const validateCloudVideoAssetUniqueness = async (
        request: ValidateCloudVideoAssetUniquenessRequest
    ): Promise<ValidationResult> => {
        return httpGet(`${baseUrl}/cloud/validate-video-uniqueness`, request);
    };

    const getOnPremAssetDetails = async (
        request: GetOnPremAssetDetailsRequest
    ): Promise<GetOnPremAssetDetailsResponse> => {
        return httpGet<GetOnPremAssetDetailsResponse>(`${baseUrl}/on-prem/get-asset-details`, request);
    };

    const getConformingCloudAssets = async (
        request: GetConformingCloudAssetsRequest
    ): Promise<GetConformingCloudAssetsResponse> => {
        return httpGet<GetConformingCloudAssetsResponse>(`${baseUrl}/cloud/get-conforming-assets`, request);
    };

    const getConformingOnPremAssets = async (
        request: GetConformingOnPremAssetsRequest
    ): Promise<GetConformingOnPremAssetsResponse> => {
        return httpGet<GetConformingOnPremAssetsResponse>(`${baseUrl}/on-prem/get-conforming-assets`, request);
    };

    const getCloudAssetPreview = async (query: GetCloudAssetPreviewRequest): Promise<GetCloudAssetPreviewResponse> => {
        return httpGet<GetCloudAssetPreviewResponse>(`${baseUrl}/cloud/get-preview`, query);
    };

    const getCloudVideoAssets = async (query: GetCloudVideoAssetsRequest): Promise<GetCloudVideoAssetsResponse> => {
        return httpGet<GetCloudVideoAssetsResponse>(`${baseUrl}/cloud/get-cloud-video-assets`, query);
    };

    const validateIfAbleToDeprecateOnPremAsset = async (
        request: ValidateIfAbleToDeprecateOnPremAssetRequest
    ): Promise<ValidationResult> => {
        return httpGet<ValidationResult>(`${baseUrl}/on-prem/validate-if-able-to-deprecate`, request);
    };

    const validateIfAbleToDeprecateCloudAsset = async (
        request: ValidateIfAbleToDeprecateCloudAssetRequest
    ): Promise<ValidationResult> => {
        return httpGet<ValidationResult>(`${baseUrl}/cloud/validate-if-able-to-deprecate`, request);
    };

    const deprecateCloudAsset = async (request: DeprecateCloudAssetRequest): Promise<void> => {
        return httpPut(`${baseUrl}/cloud/deprecate`, request);
    };

    const deprecateCloudAssetGroup = async (request: DeprecateCloudAssetGroupRequest): Promise<void> => {
        return httpPut(`${baseUrl}/cloud/deprecate-group`, request);
    };

    const validateOnPremSubtitleAssetLanguage = async (
        request: ValidateOnPremSubtitleAssetLanguageRequest
    ): Promise<ValidationResult> => {
        return httpGet(`${baseUrl}/on-prem/validate-subtitle-language`, request);
    };

    const updateOnPremSubtitleAssetLanguage = async (
        request: UpdateOnPremSubtitleAssetLanguageRequest
    ): Promise<UpdateOnPremSubtitleAssetLanguageResponse> => {
        return httpPut(`${baseUrl}/on-prem/update-subtitle-language`, request);
    };

    const validateOnPremVideoAssetUniqueness = async (
        request: ValidateOnPremVideoAssetUniquenessRequest
    ): Promise<ValidationResult> => {
        return httpGet(`${baseUrl}/on-prem/validate-video-uniqueness`, request);
    };

    const updateOnPremVideoAssetSubtitle = async (
        request: UpdateOnPremVideoAssetSubtitleRequest
    ): Promise<UpdateOnPremVideoAssetSubtitleResponse> => {
        return httpPut(`${baseUrl}/on-prem/update-video-subtitle`, request);
    };

    const getAssetsLookup = async (request: GetLookupAssetsRequest): Promise<GetLookupAssetsResponse> => {
        return httpGet<GetLookupAssetsResponse>(`${baseUrl}/lookup`, request);
    };

    const validateOnPremSoundtrackAssetLanguage = async (
        request: ValidateCloudSoundtrackAssetLanguageRequest
    ): Promise<ValidationResult> => {
        return httpGet(`${baseUrl}/on-prem/validate-soundtrack-language`, request);
    };

    const updateOnPremSoundtrackAssetLanguage = async (
        request: UpdateOnPremSoundtrackAssetLanguageRequest
    ): Promise<UpdateOnPremSoundtrackAssetLanguageResponse> => {
        return httpPut(`${baseUrl}/on-prem/update-soundtrack-language`, request);
    };

    const updateOnPremVideoAssetTechnical = async (
        request: UpdateOnPremVideoAssetTechnicalRequest
    ): Promise<UpdateOnPremVideoAssetTechnicalResponse> => {
        return httpPut(`${baseUrl}/on-prem/update-video-technical`, request);
    };

    const updateOnPremAudioAssetTechnical = async (
        request: UpdateOnPremAudioAssetTechnicalRequest
    ): Promise<UpdateOnPremAudioAssetTechnicalResponse> => {
        return httpPut(`${baseUrl}/on-prem/update-audio-technical`, request);
    };

    const updateOnPremAssetLibrary = async (
        request: UpdateOnPremAssetLibraryRequest
    ): Promise<UpdateOnPremAssetLibraryResponse> => {
        return httpPut(`${baseUrl}/on-prem/update-library`, request);
    };

    const validateOnPremAssetContent = async (
        request: ValidateOnPremAssetContentRequest
    ): Promise<ValidationResult> => {
        return httpPost(`${baseUrl}/on-prem/validate-content`, request);
    };

    const updateOnPremAssetContent = async (
        request: UpdateOnPremAssetContentRequest
    ): Promise<UpdateOnPremAssetContentResponse> => {
        return httpPut(`${baseUrl}/on-prem/update-content`, request);
    };

    const getCloudAssetsLookup = async (
        request: GetLookupCloudAssetsRequest
    ): Promise<GetLookupCloudAssetsResponse> => {
        return httpGet<GetLookupCloudAssetsResponse>(`${baseUrl}/cloud/lookup`, request);
    };

    return {
        searchAssetsContentAggregations,
        searchMovies,
        searchTvSeries,
        searchAncillary,
        getAssetsLookup,
        deprecateOnPremAsset,
        deprecateOnPremAssetGroup,
        getOnPremAssetsOperations,
        getCloudAssetsOperations,
        getCloudAssetDetails,
        getOnPremAssetDetails,
        getConformingCloudAssets,
        getConformingOnPremAssets,
        getCloudAssetPreview,
        validateIfAbleToDeprecateOnPremAsset,
        validateIfAbleToDeprecateCloudAsset,
        deprecateCloudAsset,
        deprecateCloudAssetGroup,
        updateCloudVideoAssetSubtitle,
        updateCloudVideoAssetTechnical,
        updateCloudSubtitleAssetLanguage,
        updateCloudSoundtrackAssetLanguage,
        updateCloudAssetContent,
        validateCloudSubtitleAssetLanguage,
        validateCloudSoundtrackAssetLanguage,
        validateCloudAssetContent,
        validateBulkCloudAssetContent,
        updateBulkCloudAssetContent,
        validateCloudVideoAssetUniqueness,
        validateOnPremSubtitleAssetLanguage,
        updateOnPremSubtitleAssetLanguage,
        validateOnPremVideoAssetUniqueness,
        updateOnPremVideoAssetSubtitle,
        validateOnPremSoundtrackAssetLanguage,
        updateOnPremSoundtrackAssetLanguage,
        updateOnPremVideoAssetTechnical,
        updateOnPremAudioAssetTechnical,
        updateOnPremAssetLibrary,
        validateOnPremAssetContent,
        updateOnPremAssetContent,
        getCloudAssetsLookup,
        getCloudVideoAssets
    };
};
